<template>
    <ui-modal :small="confirmationVisible">
        <template #header>
            <h3 class="mb-0 text-center" v-text="'Usuwanie karty płatniczej'" />
        </template>

        <div class="text-center mb-3">
            <a-icon icon="ErrorCircle" width="40px" height="40px" />
        </div>

        <template v-if="!confirmationVisible">
            <h6 v-text="'Czy na pewno chcesz usunąć kartę płatniczą?'" class="mb-0 text-center" />
            <h6
                v-text="`
                Ta operacja spowoduje zmianę sposobu rozliczeń i
                konieczność każdorazowego ręcznego opłacania usługi.
                `"
                class="mb-4 text-center"
            />

            <credit-card :card-info="cardInfo" />
        </template>

        <h6 v-else v-text="'Twoja karta płatnicza została usunięta'" class="mb-3 text-center" />

        <template v-if="!confirmationVisible" #footer>
            <the-btn
                text="Nie, zamknij"
                :disabled="isLoader"
                class="btn-outline-custom"
                @click="!isLoader && $emit('close-modal')"
            />
            <the-btn
                text="Tak, usuń"
                class="btn-danger"
                :loading-status="isLoader ? 'loading' : 'idle'"
                :icon="isLoader ? 'Spinner' : ''"
                @click="removeCard"
            />
        </template>
    </ui-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CreditCard from '@/components/drs/payment/CreditCard.vue'

export default {
    components: {
        CreditCard
    },

    data: () => ({
        isLoader: false,
        confirmationVisible: false
    }),

    methods: {
        ...mapActions('payment', ['updatePaymentInfo']),

        removeCard() {
            if (this.isLoader) {
                return
            }

            this.isLoader = true

            this.updatePaymentInfo({
                payment_type: 'manual'
            }).then(() => {
                this.confirmationVisible = true
            }).finally(() => {
                this.isLoader = false
            })
        }
    },

    computed: {
        ...mapGetters('payment', ['cardInfo'])
    }
}
</script>